import { useIsDesktop } from '@shared/hooks/screen'
import { Navigate, Outlet } from '@tanstack/react-router'

export const DesktopOnlyLayout = () => {
  const isDesktop = useIsDesktop()

  if (!isDesktop) {
    return <Navigate to={'/'} />
  }

  return <Outlet />
}
